// Q&Aのアコーディオンアニメーション
export const initTop = () => {
	const btn = document.querySelector(".js-message-btn");
	const wrap = document.querySelector(".js-message-wrap");
	const inner = document.querySelector(".js-message-inner");

	if (!btn || !wrap || !inner) return;

	btn.addEventListener("click", (e) => {
		e.preventDefault();
		const isOpen = wrap.classList.contains("is-open");

		if (!isOpen) {
			// 開く処理
			const innerHeight = inner.offsetHeight;
			wrap.style.height = innerHeight + "px";
			wrap.classList.add("is-open");
			btn.classList.add("is-hidden"); // ボタンを隠す
		}
	});

	const btns = document.querySelectorAll(".js-faq-btn");

	btns.forEach((btn) => {
		btn.addEventListener("click", (e) => {
			e.preventDefault();

			// 1. クラスの切り替え (色やアイコンの変化用)
			btn.classList.toggle("is-active");

			// 2. 次の要素（回答エリア）を取得
			const content = btn.nextElementSibling;

			// 3. アニメーション処理
			if (content.style.height) {
				// 開いている場合（style.heightが入っている）→ 閉じる
				content.style.height = null;
			} else {
				// 閉じている場合 → 開く
				// scrollHeight で中身の高さを取得してpx単位で設定
				content.style.height = content.scrollHeight + "px";
			}
		});
	});
};
